/**
 * @file Renders a modal that blocks the page with a spinner and a message.
 */
import React from "react";
import { Modal, Spin, Typography, Row, Space } from "antd";

const { Text } = Typography;

type Props = {
  isOpen?: boolean;
  text: React.ReactNode;
};

/**
 * Renders a non-closable modal with a spinner and a message, to block the
 * page while a background action runs.
 */
const BlockingModal = ({
  isOpen = false,
  text,
}: Props): JSX.Element => {
  const modalProps = {
    open: isOpen,
    title: null,
    footer: null,
    closable: false,
    maskClosable: false,
    destroyOnClose: true,
  };

  return (
    <Modal {...modalProps}>
      <Row justify="center">
        <Space direction="vertical" style={{ maxWidth: 340 }}>
          <Spin size="large">
            <div style={{ height: 40, width: "100%" }} />
          </Spin>

          <Text>
            <center>{text}</center>
          </Text>
        </Space>
      </Row>
    </Modal>
  );
};

export default BlockingModal;
